import Swiper from 'swiper/bundle';

export let swiperTeam;

export function initializeSwiper() {

    swiperTeam = new Swiper('.section-team__swiper .swiper', {
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 'auto',
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            992: {
                spaceBetween: 60
            },
        }
    });

    /* Gallery Slider */
    const swiperGalleryElement = document.querySelector('.section-gallery .swiper');

    if (swiperGalleryElement) {
        const swiperGallery = new Swiper('.section-gallery .swiper', {
            speed: 400,
            spaceBetween: 0,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            lazy: true,
            pagination: {
                el: '.section-gallery .swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.section-gallery .swiper-button-next',
                prevEl: '.section-gallery .swiper-button-prev',
            },
        });

    }

    /* Reference Slider */

    const swiperReferenceElement = document.querySelector('.section-reference .swiper');

    function updateSwiperCounter(swiperName) {
        const currentSlide = swiperName.realIndex + 1;
        const totalSlides = swiperName.slides.length;
        if (totalSlides > 1) {
            document.querySelector('.swiper-button-count').textContent = `${currentSlide} / ${totalSlides}`;
        }

    }

    if (swiperReferenceElement) {
        const swiperReference = new Swiper('.section-reference__swiper .swiper', {
            speed: 400,
            spaceBetween: 0,
            pagination: {
                el: '.section-reference .swiper-pagination',
                type: 'progressbar',
            },
            navigation: {
                nextEl: '.section-reference .swiper-button-next',
                prevEl: '.section-reference .swiper-button-prev',
            },
            simulateTouch: false,
            autoHeight: true,
            on: {
                slideChange: function () {
                    updateSwiperCounter(swiperReference);
                },
            },
        });

        updateSwiperCounter(swiperReference);
    }

    /* Home Hero Slider */
    const swiperHeroElement = document.querySelector('.section-hero-slider .swiper');

    if (swiperHeroElement) {
        const swiperHero = new Swiper('.section-hero-slider .swiper', {
            speed: 400,
            spaceBetween: 0,
            direction: 'vertical',
            navigation: {
                nextEl: '.section-hero-slider .swiper-button-next',
                prevEl: '.section-hero-slider .swiper-button-prev',
            },
            loop: true,
            allowTouchMove: false,
            simulateTouch: false,
            touchStartPreventDefault: false,
        });
    }


    /*  Columns Slider */
    const swiperColumnsElement = document.querySelector('.columns-slider .swiper');
    let swiperStack;

    if (swiperColumnsElement) {
        if (window.innerWidth >= 992) {
            swiperStack = new Swiper(".columns-slider .swiper", {
                effect: "cards",
                cardsEffect: {
                    rotate: false,
                },
            });
        } else {
            swiperStack = new Swiper(".columns-slider .swiper", {
                effect: "slide",
                slidesPerView: 'auto',
                grabCursor: false,
                spaceBetween: 12,
                loop: true,
            });
        }

        const slides = document.querySelectorAll('.navi a');

        slides.forEach((slide, index) => {
            slide.addEventListener('mouseover', () => {
                slides.forEach(s => s.classList.remove('active'));
                swiperStack.slideTo(index);
                slide.classList.add('active');
            });

            slide.addEventListener('mouseleave', () => {
                slides.forEach(s => s.classList.remove('active'));
                slides[0].classList.add('active');
                swiperStack.slideTo(0);
            });
        });
    }

    function updateActiveButton(swiper) {
        document.querySelectorAll('.tab-nav__button').forEach(btn => {
            btn.classList.remove('tab-nav__button--active');
        });

        const button = document.querySelector(
            `.tab-nav__button[data-id="${swiper.realIndex}"]`
        );
        if (button) button.classList.add('tab-nav__button--active');
    }

    const swiperTabElements = document.querySelector('.section-tab .swiper');

    if (swiperTabElements) {
        const swiperTab = new Swiper(".section-tab .swiper", {
            speed: 400,
            spaceBetween: 20,

            on: {
                init: function () { updateActiveButton(this); },
                slideChange: function () { updateActiveButton(this); },
            }

        });

        const navigation = document.querySelectorAll('.tab-nav__button');

        navigation.forEach((button, index) => {
            button.addEventListener('click', () => {
                navigation.forEach(s => s.classList.remove('tab-nav__button--active'));
                swiperTab.slideTo(index);
                button.classList.add('tab-nav__button--active');
            });
        });
    }
}
